export default __webpack_public_path__ + "75d4969417a9974e3971d41a8a161d4a.png";